var _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path10;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgVector1(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 32,
    height: 32,
    viewBox: "0 0 32 32",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M25.94 25.99H4.58C3.71 25.99 3 25.29 3 24.41V6.58C3 5.71 3.71 5 4.58 5H25.94C26.82 5 27.52 5.71 27.52 6.58V24.41C27.53 25.29 26.82 25.99 25.94 25.99Z",
    stroke: "#B44755",
    strokeWidth: 1.7,
    strokeMiterlimit: 10
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M5.72 3.43H1.8V7.35H5.72V3.43Z",
    fill: "white",
    stroke: "#332044",
    strokeWidth: 1.7,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M28.88 3.43H24.96V7.35H28.88V3.43Z",
    fill: "white",
    stroke: "#332044",
    strokeWidth: 1.7,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M5.72 23.17H1.8V27.09H5.72V23.17Z",
    fill: "white",
    stroke: "#332044",
    strokeWidth: 1.7,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M28.88 23.17H24.96V27.09H28.88V23.17Z",
    fill: "white",
    stroke: "#332044",
    strokeWidth: 1.7,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M15.27 17.08C16.1426 17.08 16.85 16.3726 16.85 15.5C16.85 14.6274 16.1426 13.92 15.27 13.92C14.3974 13.92 13.69 14.6274 13.69 15.5C13.69 16.3726 14.3974 17.08 15.27 17.08Z",
    fill: "#B44654"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M3 16.6C3.60751 16.6 4.1 16.1075 4.1 15.5C4.1 14.8925 3.60751 14.4 3 14.4C2.39249 14.4 1.9 14.8925 1.9 15.5C1.9 16.1075 2.39249 16.6 3 16.6Z",
    fill: "white",
    stroke: "#332044",
    strokeWidth: 0.4,
    strokeMiterlimit: 10
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M15.27 6.1C15.8775 6.1 16.37 5.60751 16.37 5C16.37 4.39249 15.8775 3.9 15.27 3.9C14.6625 3.9 14.17 4.39249 14.17 5C14.17 5.60751 14.6625 6.1 15.27 6.1Z",
    fill: "white",
    stroke: "#332145",
    strokeWidth: 0.4,
    strokeMiterlimit: 10
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M27.53 16.6C28.1375 16.6 28.63 16.1075 28.63 15.5C28.63 14.8925 28.1375 14.4 27.53 14.4C26.9225 14.4 26.43 14.8925 26.43 15.5C26.43 16.1075 26.9225 16.6 27.53 16.6Z",
    fill: "white",
    stroke: "#332044",
    strokeWidth: 0.4,
    strokeMiterlimit: 10
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    d: "M15.26 27.09C15.8675 27.09 16.36 26.5975 16.36 25.99C16.36 25.3825 15.8675 24.89 15.26 24.89C14.6525 24.89 14.16 25.3825 14.16 25.99C14.16 26.5975 14.6525 27.09 15.26 27.09Z",
    fill: "white",
    stroke: "#332044",
    strokeWidth: 0.4,
    strokeMiterlimit: 10
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgVector1);
export default __webpack_public_path__ + "static/media/vector1.aee481002fff93bc6937019816134feb.svg";
export { ForwardRef as ReactComponent };